import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { ICliente } from '../models/cliente';
import { environment } from 'src/environments/environment';
import { IEstatusUnidad } from '../models/estatusunidad';
import { ISubEstatusUnidad } from '../models/subestatusunidad';
import { IDataEstatus } from '../models/dataEstatus';

@Injectable({
  providedIn: 'root'
})
export class EstatusunidadService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) { 
    this.apiUrl = environment.SUrlgApi + 'UnidadEstatus';
  }


  getListadoEstatusUnidad(): Observable<IEstatusUnidad[]> {
    return this.http
      .get<IEstatusUnidad[]>(this.apiUrl+'/GetListaEstatusUnidad')
      .pipe(retry(1), catchError(this.handleError));
  }

  getListadoSubEstatusUnidad(): Observable<ISubEstatusUnidad[]> {
    return this.http
      .get<ISubEstatusUnidad[]>(this.apiUrl+'/GetListaSubEstatusUnidad')
      .pipe(retry(1), catchError(this.handleError));
  }

  

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
